const MOBILE_PHONE_USER_AGENT =
  /Android.+Mobile|iPhone|iPod|Windows Phone|IEMobile|Opera Mini|Mobi/i;
const TELEVISION_USER_AGENT =
  /QAssistAndroidTV|Android TV|GoogleTV|SmartTV|SMART-TV|HbbTV|Tizen|Web0S|webOS/i;
const TABLET_USER_AGENT = /iPad|Tablet|Kindle|Silk/i;

export function isMobilePhoneBrowser({
  userAgent,
  maxTouchPoints,
  screenWidth,
  screenHeight,
}: {
  userAgent: string;
  maxTouchPoints: number;
  screenWidth: number;
  screenHeight: number;
}): boolean {
  if (TELEVISION_USER_AGENT.test(userAgent)) return false;
  if (TABLET_USER_AGENT.test(userAgent)) return false;
  if (MOBILE_PHONE_USER_AGENT.test(userAgent)) return true;
  return maxTouchPoints > 0 && Math.min(screenWidth, screenHeight) < 600;
}

export function currentBrowserIsMobilePhone(): boolean {
  return isMobilePhoneBrowser({
    userAgent: navigator.userAgent,
    maxTouchPoints: navigator.maxTouchPoints,
    screenWidth: window.screen.width,
    screenHeight: window.screen.height,
  });
}

export type MobilePhoneRouteSurface =
  "player" | "menu" | "landing" | "resolving-public-route" | "unsupported";

export function mobilePhoneRouteSurface({
  pathname,
  configuredPlayerRoute,
  brandingPending,
}: {
  pathname: string;
  configuredPlayerRoute: boolean;
  brandingPending: boolean;
}): MobilePhoneRouteSurface {
  if (pathname === "/player" || configuredPlayerRoute) return "player";
  if (/^\/menu\/[^/]+(?:\/|$)/.test(pathname)) return "menu";
  if (pathname === "/") return brandingPending ? "resolving-public-route" : "landing";
  const knownManagementRoute =
    /^\/(?:login(?:-admin)?|reset-password|admin(?:\/|$)|client(?:\/|$)|unavailable(?:\/|$))/.test(
      pathname,
    );
  return brandingPending && !knownManagementRoute ? "resolving-public-route" : "unsupported";
}
